import { render, staticRenderFns } from "./JobDescriptionPage.vue?vue&type=template&id=2acaa9cd&"
import script from "./JobDescriptionPage.vue?vue&type=script&lang=js&"
export * from "./JobDescriptionPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports